import { render, staticRenderFns } from "./DotLoadingPage.vue?vue&type=template&id=3fd73dde&scoped=true&"
import script from "./DotLoadingPage.vue?vue&type=script&lang=js&"
export * from "./DotLoadingPage.vue?vue&type=script&lang=js&"
import style0 from "./DotLoadingPage.vue?vue&type=style&index=0&id=3fd73dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd73dde",
  null
  
)

export default component.exports